import { useMemo } from 'react';
import { SanityImage } from 'schema/studio/common/image';
import { urlFor, type PartialSanityImageAsset } from 'shared/utils/urlFor';
import { SanityImageAsset, SanityReference } from 'types/studio/studio';

type Props = {
  icon: Pick<SanityImage, 'alt' | 'url'>;
  className?: string;
  eagerLoading?: boolean;
};

const StudioBaseIcon = ({ icon, className, eagerLoading = false }: Props) => (
  <img
    alt={icon.alt || ''}
    className={className}
    src={icon.url}
    decoding="async"
    loading={eagerLoading ? 'eager' : 'lazy'}
    role="presentation"
  />
);

type PropsV2 = {
  icon: {
    asset: SanityReference<SanityImageAsset> | PartialSanityImageAsset;
    alt?: string;
  };
  eagerLoading?: boolean;
  className?: string;
};

export const StudioBaseIconV2 = ({ icon, ...props }: PropsV2) => {
  const formatIcon = useMemo(
    () => ({
      alt: '',
      ...icon,
      ...urlFor(icon)
    }),
    [icon]
  );

  return <StudioBaseIcon {...props} icon={formatIcon} />;
};

export default StudioBaseIcon;
